export default "__VITE_ASSET__XzYPCZN$__"